import { render, staticRenderFns } from "./panel_administrativo.vue?vue&type=template&id=e3fc6b98&scoped=true"
import script from "./panel_administrativo.vue?vue&type=script&lang=js"
export * from "./panel_administrativo.vue?vue&type=script&lang=js"
import style0 from "./panel_administrativo.vue?vue&type=style&index=0&id=e3fc6b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fc6b98",
  null
  
)

export default component.exports